/**
 * Übersetzt die Fehlercodes aus amplify/functions/verkostung-schreiben/handler.ts
 * (dort per `fehler('CODE')` geworfen, kommt als GraphQL-Fehlermeldung zurück)
 * in verständliche deutsche Hinweise. Gemeinsam genutzt von NeueVerkostung.tsx
 * und VerkostungBearbeiten.tsx, damit beide Formulare dieselben Meldungen zeigen.
 */
export function uebersetzeSchreibFehler(code: string): string {
  if (code.includes('TAGESLIMIT_ERREICHT')) return 'Tageslimit erreicht: max. 5 Verkostungen pro Tag.';
  if (code.includes('PFLICHTNOTEN_FEHLEN')) return 'Bitte die vier Pflichtkriterien bewerten.';
  if (code.includes('UNGUELTIGE_NOTE')) return 'Eine der Noten ist ungültig (erlaubt: 1 bis 5).';
  if (code.includes('UNGUELTIGER_WERT')) return 'Einer der ausgewählten Werte ist ungültig — bitte die Auswahl prüfen.';
  if (code.includes('NICHT_BERECHTIGT')) return 'Dafür fehlt dir die Berechtigung.';
  if (code.includes('NUR_ENTWURF_BEARBEITBAR')) return 'Nur Entwürfe lassen sich bearbeiten.';
  if (code.includes('NUR_ENTWURF_LOESCHBAR')) return 'Nur Entwürfe lassen sich löschen.';
  if (code.includes('BEREITS_VEROEFFENTLICHT')) return 'Diese Verkostung ist bereits veröffentlicht.';
  if (code.includes('NUR_VERWALTER')) return 'Das dürfen nur Verwalter.';
  if (code.includes('NICHT_GEFUNDEN')) return 'Diese Verkostung wurde nicht gefunden.';
  if (code.includes('UNGUELTIGER_DATEITYP')) return 'Dieser Dateityp wird nicht unterstützt.';
  return code;
}
